export { default } from './post-loader';
